var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', {
    attrs: {
      "scrollable": ""
    }
  }, [_c('v-row', {
    staticClass: "pa-5 ma-0"
  }, [_c('v-col', {
    staticClass: "py-0"
  }, [_c('v-form', {
    ref: "brand-form",
    model: {
      value: _vm.valid,
      callback: function ($$v) {
        _vm.valid = $$v;
      },
      expression: "valid"
    }
  }, [_c('v-row', [_c('v-col', {
    staticClass: "pt-0"
  }, [_c('v-text-field', {
    attrs: {
      "name": "name",
      "persistent-hint": "",
      "label": _vm.$t('brand_name'),
      "hint": _vm.$t('brand_name_hint'),
      "rules": _vm.rules.required,
      "error-messages": _vm.errorMessages.name,
      "required": ""
    },
    on: {
      "focus": function ($event) {
        return _vm.clearErrors('name');
      }
    },
    model: {
      value: _vm.brandForm.name,
      callback: function ($$v) {
        _vm.$set(_vm.brandForm, "name", $$v);
      },
      expression: "brandForm.name"
    }
  })], 1), _c('v-col', {
    staticClass: "pt-0"
  }, [_c('v-text-field', {
    attrs: {
      "name": "reference",
      "persistent-hint": "",
      "label": _vm.$t('brand_reference'),
      "hint": _vm.$t('brand_reference_hint'),
      "rules": _vm.rules.required,
      "error-messages": _vm.errorMessages.reference,
      "required": ""
    },
    on: {
      "focus": function ($event) {
        return _vm.clearErrors('reference');
      }
    },
    model: {
      value: _vm.brandForm.reference,
      callback: function ($$v) {
        _vm.$set(_vm.brandForm, "reference", $$v);
      },
      expression: "brandForm.reference"
    }
  })], 1)], 1)], 1)], 1)], 1), _c('v-card-actions', {
    staticClass: "action-buttons"
  }, [_vm.brandForm.id ? _c('div', {
    staticClass: "mr-2 d-flex flex-column align-start"
  }, [_c('v-alert', {
    staticClass: "delete-warning",
    attrs: {
      "icon": "mdi-alert-circle-outline",
      "type": "error",
      "dense": "",
      "text": ""
    }
  }, [_vm.showDeleteBlockedMessage ? _c('span', [_vm._v(_vm._s(_vm.$t('brand_delete_blocked')))]) : _vm.errorMessages.delete.length ? _c('span', [_vm._v(_vm._s(_vm.errorMessages.delete[0]))]) : _vm._e()]), _c('v-btn', {
    attrs: {
      "loading": _vm.isBrandProductsInfoLoading || _vm.isDeletingBrand,
      "color": "error",
      "text": ""
    },
    on: {
      "click": function ($event) {
        return _vm.handleDelete();
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-delete")]), _c('span', {
    staticClass: "delete-btn"
  }, [_vm._v(_vm._s(_vm.$t('brand_delete')))])], 1)], 1) : _vm._e(), _c('v-spacer'), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function ($event) {
        return _vm.handleClose();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('close')))]), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "primary",
      "loading": _vm.savingBrand
    },
    on: {
      "click": function ($event) {
        return _vm.handleSave();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('save')))])], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }